/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 6/23/2023
 */
import React, { useEffect, useState } from "react";
import ApprovedOrgsItem from "./ApprovedOrgsItem";
import { Stack,LinearProgress,Paper,InputBase,IconButton } from "@mui/material";
import api from "../../../../base/services/ResApi";
import { FetchErrorHandeling } from "../../../../base/errorHandeling/FetchErrorHandeling";
import Alerts from "../../../../base/errorHandeling/Alerts";
import SearchIcon from "@mui/icons-material/Search"

const ApprovedOrgs = ({
  updateData,
  refreshKey = 0,
  setUpdateData,
}) => {
  const [approvedData, setApprovedData] = useState([])
  const [filterData, setfilterData] = useState([])
  const [apprLoading, setApprDataLoading] = useState(true)

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [isUnauhtError, setIsUnauhtError] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  let apprvConfig = {
    headers: {
      Action: "V_APPR_ORG",
      "Page-Number": 1,
      "Page-Size": 500,
      "Sort-Column": "org_code",
      "Sort-Order": "asc",
    },
  }

  useEffect(() => {
    setApprDataLoading(true)
    api
      .get("/organizations", apprvConfig)
      .then((res) => {
        setApprovedData(res.data?.dataList)
        setfilterData(res.data?.dataList)
        setApprDataLoading(false)
        setErrorMessages([])
        setIserror(false)
        setIsUnauhtError(false)
        setUpdateData(false)
      })
      .catch((error) => {
        setUpdateData(false)
        setApprDataLoading(false)
        FetchErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        )
      })
  }, [updateData, isUnauhtError, refreshKey])

  useEffect(() => {
    if (iserror === true) {
      setTimeout(() => {
        setIserror(false)
        setErrorMessages([])
      }, 10000)
    }
  }, [iserror])

  useEffect(() => {
    if (isSuccess === true) {
      setTimeout(() => {
        setIsSuccess(false)
        setSuccessMessages([])
      }, 3000)
    }
  }, [isSuccess])

  const searchFilter = (e) => {
    const searchVal = e.target.value
    const results = approvedData.filter((org) => {
      return org.orgName.toLowerCase().includes(searchVal.toLowerCase())
    })
    setfilterData(results)
  }

  return (
    <div>
      <div>
        <Alerts
          iserror={iserror}
          errorMessages={errorMessages}
          isSuccess={isSuccess}
          successMessages={successMessages}
          iserrorShow={iserrorShow}
        />
      </div>
      <Paper
        component="form"
        sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: "100%", maxWidth: 360, minHeight: 58, mb: 3 }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Search Organization"
          inputProps={{ "aria-label": "search organization" }}
          onChange={searchFilter}
        />
        <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
          <SearchIcon />
        </IconButton>
      </Paper>
      <br />
      {apprLoading ? (
        <div>
          <LinearProgress />
        </div>
      ) : (
        <Stack
          sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 360px), 1fr))", gap: 2.5, alignItems: "stretch" }}
        >
          {filterData.map((orgData, i) => {
            return (
              <ApprovedOrgsItem
                key={orgData?.orgCode}
                orgData={orgData}
                setIsSuccess={setIsSuccess}
                setSuccessMessages={setSuccessMessages}
                setUpdateData={setUpdateData}
                setIserror={setIserror}
                setErrorMessages={setErrorMessages}
                setIsUnauhtError={setIsUnauhtError}
                setIserrorShow={setIserrorShow}
              />
            )
          })}
        </Stack>
      )}
    </div>
  )
}
export default ApprovedOrgs;
